import * as api from '@/lti/api'
import { storeAllEntities } from '@/lti/store/helpers'
export default {
  state: {
    events: {},
    event_students: {},
    student_event_contexts: {},
    assessmentConfigs: {},
  },

  mutations: {

  },

  actions: {
    getCourseEvents ({ commit, state }, courseId) {
      return api.getCourseEvents(courseId)
        .then(storeAllEntities(commit))
        .then(resources => {
          commit('SET_COURSE_EVENTS', {
            courseId,
            eventIds: (resources.events || []).map(event => event.id),
          })

          return resources
        })
    },
    getLesson ({ commit, state }, { courseId, lessonId, params }) {
      return api.getLesson(courseId, lessonId, params)
        .then(storeAllEntities(commit))
    },
    storeAttendancesByNumber ({ commit, state }, { courseId, lessonId, postData }) {
      return api.storeAttendancesByNumber(courseId, lessonId, postData)
        .then(storeAllEntities(commit))
    },
  },

  getters: {},
}
